export default class TableRow {
  name: string = "";
  played: number = 0;
  won: number = 0;
  drawn: number = 0;
  lost: number = 0;
  for: number = 0;
  against: number = 0;
  points: number = 0;
}